import * as React from 'react';
import * as classNames from 'classnames';
import {BubbleError} from '../bubble-error/bubble-error';

import './styles.sass';

interface ITextAreaProps {
  rows?: number;
  error?: string;
  focused?: boolean;
  disabled?: boolean;
  defaultValue: string;
  placeholder?: string;
  onChange: (e: any) => void;
}

export class TextArea extends React.Component<ITextAreaProps, {}> {
  private currentElement: HTMLTextAreaElement;

  public componentDidMount(): void {
    this.focus();
  }

  public componentDidUpdate(): void {
    this.focus();
  }

  public render(): React.ReactElement<any> {
    const {defaultValue, onChange, rows, placeholder, disabled, error} = this.props;
    return (
      <div className={'textarea-container'}>
        <textarea
          rows={rows || 3}
          onChange={onChange}
          disabled={disabled}
          placeholder={placeholder}
          defaultValue={defaultValue}
          ref={node => this.currentElement = node}
          className={classNames('textarea-container__text', {
            'textarea-container__text_error': error,
          })}
        />
        <BubbleError error={error}/>
      </div>
    );
  }

  private focus = (): void => {
    this.props.focused && this.currentElement.focus();
  };
}
